import axios from "axios"
import React, { Component } from "react"
import { Button, Modal, ProgressBar, Spinner } from "react-bootstrap"
//@ts-ignore
import FileViewer from "react-file-viewer"
import moment from "moment"
import AxiosConfig from "../../../../utilities/AxiosConfig"
import IconBuilder from "../../../../utilities/iconBuilder/IconBuilder"
import reggie from "../../../../utilities/Reggie"
import snackBar from "../../../../utilities/snackBar/SnackBar"
import directoryBuilder from "src/utilities/directoryBuilder"
import "./DocUploader.css"

interface DocUploaderProps {
    toggleDocUploader: Function
    maintenanceID: string | number | any
    contextUserId: string | number
    refreshTimeline: Function
    storageLocation: string
    containerName: string
    fileStoreLocationId: string
    attachedToTypeId?: string
}

type DocUploaderTypes = {
    file: string | null
    blob: any
    path: string | null
    extension: string | null
    loadingFile: boolean
    uploadingFile: boolean
    drag: boolean
    uploadProgress: number
    title: string
    annotation: string
    displayName: string
}

class DocUploader extends Component<DocUploaderProps, DocUploaderTypes> {

    storageLocation = process.env.REACT_APP_FLEET_MAINTENANCE_FILES_STORAGE_LOCATION
    containerName = process.env.REACT_APP_FLEET_MAINTENANCE_FILES_CONTAINER_NAME
    fileStoreLocationId = process.env.REACT_APP_FLEET_MAINTENANCE_FILES_FILE_STORE_LOCATION_ID

    dropRef: any = React.createRef()
    dragCounter: any

    state = {
        file: null,
        blob: null,
        path: null,
        extension: null,
        loadingFile: false,
        uploadingFile: false,
        drag: false,
        uploadProgress: 0,
        title: "",
        annotation: "",
        displayName: "NA"
    }

    componentDidMount() {
        let div: any = this.dropRef.current
        div.addEventListener('dragenter', this.handleDragIn)
        div.addEventListener('dragleave', this.handleDragOut)
        div.addEventListener('dragover', this.handleDrag)
        div.addEventListener('drop', this.handleDrop)
        document.addEventListener('keydown', this.handleKeyDown)
    }

    componentWillUnmount() {
        let div: any = this.dropRef.current
        div.removeEventListener('dragenter', this.handleDragIn)
        div.removeEventListener('dragleave', this.handleDragOut)
        div.removeEventListener('dragover', this.handleDrag)
        div.removeEventListener('drop', this.handleDrop)
        document.removeEventListener('keydown', this.handleKeyDown)
    }

    buildRelativePath = () => {
        const id: number | string = parseInt(this.props.maintenanceID)
        // //@ts-ignore
        //@ts-ignore
        return `${directoryBuilder.calculateDirectory(id)}/${id}_${Date.now()}_${this.state.blob.name.replace(/\s/g, "")}`
    }

    handleKeyDown = (event: { keyCode: number }) => {
        if (event.keyCode === 13 && this.state.file) {
            this.upload()
        }
    }

    handleDrag = (e: any) => {
        e.preventDefault()
        e.stopPropagation()
    }

    handleDragIn = (e: any) => {
        e.preventDefault()
        e.stopPropagation()
        this.dragCounter++
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            this.setState({ drag: true })
        }
    }

    handleDragOut = (e: any) => {
        e.preventDefault()
        e.stopPropagation()
        this.dragCounter--
        if (this.dragCounter === 0) {
            this.setState({ drag: false })
        }
    }

    handleDrop = (e: any) => {
        e.preventDefault()
        e.stopPropagation()
        this.setState({ drag: false })
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            // this.props.handleDrop(e.dataTransfer.files)
            this.fileSelectedHandler({ target: { files: e.dataTransfer.files } })
            e.dataTransfer.clearData()
            this.dragCounter = 0
        }
    }

    upload = () => {
        this.fileUploadHandler()
    }

    purge = () => {
        this.setState({
            file: null,
            blob: "",
            path: "",
            extension: null,
            loadingFile: false,
            uploadingFile: false,
            uploadProgress: 60
        })
    }

    // handleChange = (event: { target: { value: string } }) => {
    //     this.setState({ annotation: event.target.value })
    // }

    fileSelectedHandler = (event: any) => {
        //console.log(":)", event.target.files)
        if (event.target.files && event.target.files[0]) {
            this.setState({ file: null, extension: null, loadingFile: true })
            let file = event.target.files[0];
            let infoId = this.props.maintenanceID
            let date = Date.now()
            let regex = /(?:\.([^.]+))?$/
            //@ts-ignore
            let extension = regex.exec(file.name)[1]
            let path = `${infoId}_${date}`
            const self = this
            setTimeout(() => {
                self.setState({
                    file: URL.createObjectURL(file),
                    blob: file,
                    extension: extension,
                    path: path,
                    loadingFile: false,
                    displayName: reggie.joinString(file.name)
                })
            }, 500)
        }
    }

    fileUploadHandler = () => {
        const file: any = this.state.blob
        const path: any = this.state.path
        const name = reggie.joinString(file.name)
        const config = AxiosConfig.configValue();

        // //console.log("File: ", file)
        // //console.log("Path: ", path)

        if (file && path) {
            this.setState({ uploadingFile: true })
            let fd = new FormData()
            const relativePath = this.buildRelativePath()
            fd.append('File', file, file.name)
            fd.append("Json",
                JSON.stringify({
                    RelativePathAndName: relativePath,
                    storageLocation: this.props.storageLocation,
                    ContainerName: this.props.containerName
                })
            )
            axios.request({
                method: "post",
                url: process.env.REACT_APP_IMG_API_URL + "/api/file",
                data: fd,
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    Accept: "application/json",
                    Authorization: "Bearer " + config.headers.authorization.split(" ")[1]
                },
                maxContentLength: 10000000,
                //@ts-ignore
                maxBodyLength: 10000000,
                onUploadProgress: (ProgressEvent: any) => {
                    let progress = Math.round(ProgressEvent.loaded / ProgressEvent.total * 100)
                    if (progress >= 10) {
                        this.setState({ uploadProgress: progress - 10 })
                    } else {
                        this.setState({ uploadProgress: progress })
                    }
                }
            }).then(() => {
                this.fileAttachToHandler(name, relativePath)
            }).catch(() => {
                snackBar({ type: "error", text: "Encountered an error during the file upload process", timeout: 3000 })
                this.purge()
            })
        } else {
            snackBar({ type: "error", text: "Encountered an error during the file upload process", timeout: 3000 })
        }
    }

    fileAttachToHandler = (name: string, relativePath: string) => {

        let requestBody = {
            AttachmentId: null,
            AttachedToTypeID: this.props.attachedToTypeId ?? "10",
            AttachmentTypeID: "3",
            AttachedToID: this.props.maintenanceID,
            Name: name.replace(/\.[^/.]+$/, ""),
            ImageFileStoreLocationID: this.props.fileStoreLocationId,
            RelativePath: `/${relativePath}`,
            Comments: null,
            CreatedDate: moment().format(),
            CreatedBy: parseInt(this.props.contextUserId + ""),
            ModifyDate: moment().format(),
            ModifiedBy: parseInt(this.props.contextUserId + ""),
            DeletedDate: null,
            DeletedBy: null,
            DisabledDate: null,
            DisabledBy: null,
            Option1: null,
            Option2: moment().format(),
            Option3: null,
            Option4: null,
            Status: 0
        }

        axios.post(process.env.REACT_APP_API_URL + "/api/Data/AddOrUpdateAttachment", requestBody, AxiosConfig.configValue("min"))
            .then(() => {
                this.setState({ uploadProgress: this.state.uploadProgress + 5 })
                this.props.toggleDocUploader()
            }).catch(err => {
                //console.log(err)
                snackBar({ type: "error", text: "Encountered an error during the file upload process", timeout: 3000 })
                this.purge()
            })
    }

    render() {

        let file: any = this.state.file
        let extension = this.state.extension

        return (
            <div className="DocUploader">
                <Modal id="timeline-large-view-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                    size="xl"
                >
                    <Modal.Body>
                        <div className="DocUploaderModalBody" ref={this.dropRef}>
                            {!file && !this.state.loadingFile && <div className="DocUploaderModalBodySupportedFileTypes">
                                <div className="DocUploaderModalBodySupportedFileType">
                                    <IconBuilder
                                        extension={"png"}
                                        size={32}
                                    />
                                    <p>Images: png, jpeg, gif, bmp</p>
                                </div>
                                <div className="DocUploaderModalBodySupportedFileType">
                                    <IconBuilder
                                        extension={"pdf"}
                                        size={32}
                                    />
                                    <p>pdf</p>
                                </div>
                                <div className="DocUploaderModalBodySupportedFileType">
                                    <IconBuilder
                                        extension={"csv"}
                                        size={32}
                                    />
                                    <p>csv</p>
                                </div>
                                <div className="DocUploaderModalBodySupportedFileType">
                                    <IconBuilder
                                        extension={"xlsx"}
                                        size={32}
                                    />
                                    <p>xlsx</p>
                                </div>
                                <div className="DocUploaderModalBodySupportedFileType">
                                    <IconBuilder
                                        extension={"docx"}
                                        size={32}
                                    />
                                    <p>docx</p>
                                </div>
                                <div className="DocUploaderModalBodySupportedFileType">
                                    <IconBuilder
                                        extension={"mp4"}
                                        size={32}
                                    />
                                    <p>Video: mp4, webm</p>
                                </div>
                                <div className="DocUploaderModalBodySupportedFileType">
                                    <IconBuilder
                                        extension={"mp3"}
                                        size={32}
                                    />
                                    <p>Audio: mp3</p>
                                </div>
                            </div>}
                            {!file && <div className="DocUploaderBackground">
                                <span className="material-icons" id="doc-uploader-background">snippet_folder</span>
                                <p>Drop a file to upload here.</p>
                            </div>}
                            {this.state.loadingFile && <Spinner id="loading-file-spinner" animation="border" />}
                            {file && !this.state.loadingFile && !this.state.uploadingFile && <FileViewer
                                fileType={extension}
                                filePath={file}
                                errorComponent={<div></div>}
                                onError={() => null}
                            />}
                            {this.state.uploadingFile && <span className="material-icons" id="doc-upload-progress-spinner-thing">snippet_folder</span>}
                            {this.state.uploadingFile && <ProgressBar id="file-upload-progress-bar" now={this.state.uploadProgress} label={`${this.state.uploadProgress}%`} />}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="DocUploaderModalFooter">
                            {!this.state.uploadingFile && <Button variant="secondary" onClick={() => this.props.toggleDocUploader([{ key: "uploadDocument" }])}>Back</Button>}
                            {file && extension && <div className="DocUploaderModalFooterFileName">
                                <p>{this.state.displayName}</p>
                                <IconBuilder
                                    extension={extension}
                                    size={48}
                                />
                            </div>}
                            {!file && !this.state.uploadingFile && <div className="DocUploaderChoseFileWrapper">
                                <label htmlFor="ChooseFile" className="doc-file-upload">
                                    <span className="material-icons">attach_file</span>
                                </label>
                                <input id="ChooseFile" type="file" onChange={this.fileSelectedHandler} />
                            </div>}
                            {file && !this.state.uploadingFile && <div className="DocFileUploadWrapper">
                                <span id="doc-uploader-purge-btn" onClick={() => this.purge()} className="material-icons">clear</span>
                                <span id="doc-uploader-upload-btn" onClick={() => this.upload()} className="material-icons">file_upload</span>
                            </div>}
                            {this.state.uploadingFile && <Spinner id="doc-uploader-uploading-spinner" animation="border" />}
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default DocUploader